module.exports = __webpack_public_path__ + "product-pure-powder-capsule-07.jpg?f871f8ff5dca2620e908d3b1163afdc2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-07.jpg
// module id = 89
// module chunks = 0